import React from 'react';
import { XIcon } from 'lucide-react';
import { painPoints } from '../data/content';
import { Reveal } from './Reveal';
export function PainPoints() {
  return <section className="w-full bg-white py-16 sm:py-24" aria-labelledby="dolor-title" data-id="element-189" data-mp="2lpeuecmv95yb">
      <div className="mx-auto max-w-6xl px-6" data-id="element-190" data-mp="26y60vsfuf0fw">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1fr)] lg:gap-20" data-id="element-191" data-mp="2bwzd7hje8leh">
          <Reveal data-id="element-192" data-mp="1xx85tzndu39g">
            <h2 id="dolor-title" className="font-display text-3xl leading-tight text-ink sm:text-4xl lg:text-[2.75rem]" data-id="element-193" data-mp="1xwon4gpwraud">
              Si intentas comer bien y aun así notas pesadez o hinchazón abdominal,
              <span className="block text-mint-700" data-id="element-194" data-mp="1o0lj15bhx24s">este Megapack te ayuda a poner orden.</span>
            </h2>
            <p className="mt-6 max-w-md text-lg text-ink-soft" data-id="element-195" data-mp="1sz6n5ftvc5yi">
              Muchas personas no saben por dónde empezar: qué comer, cómo organizar
              la compra o cómo detectar qué hábitos les sientan mejor. El Megapack
              reúne esa información en una ruta ordenada.
            </p>
            <p className="mt-8 font-display text-2xl text-ink sm:text-[1.75rem]" data-id="element-196" data-mp="1yz3xp0jvc8hw">
              ¿Y si, en lugar de buscar información suelta, tuvieras un plan claro
              para organizar tus comidas?
            </p>
            <p className="mt-6 max-w-md text-sm leading-relaxed text-ink-muted" data-id="element-197" data-mp="27ute0v6gmcof">
              Si tus síntomas son intensos, nuevos o persistentes, consulta con un
              profesional sanitario.
            </p>
          </Reveal>

          <Reveal delay={0.06} data-id="element-198" data-mp="1b39efl37edcq">
            <ul className="divide-y divide-mint-100 border-y border-mint-100" data-id="element-199" data-mp="1b4amdgoxajq8">
              {painPoints.map(point => <li key={point} className="flex items-start gap-4 py-5" data-id="element-200" data-mp="1p425fvuaqqb3">
                  <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-mint-50 text-mint-700" aria-hidden="true" data-id="element-201" data-mp="1k2cushazkenj">
                    <XIcon className="h-4 w-4" strokeWidth={2.5} data-id="element-202" data-mp="30jh557dw3w9w" />
                  </span>
                  <span className="text-base leading-relaxed text-ink sm:text-lg" data-id="element-203" data-mp="2vknsfh6fg9as">
                    {point}
                  </span>
                </li>)}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>;
}